const TEXT_SIZES = {
  XL: 30,
  Large: 22,
  Normal: 18,
  Small: 14,
};

export default TEXT_SIZES;
